import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import { TypedMap } from 'utils/typed-map';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  UPDATE,
  UPDATE_SUCCESS,
  UPDATE_FAILED,
  SET_FETCH_PARAMS,
} from './constants';

export type OrganizersListPageState = TypedMap<{
  loading: boolean;
  error: any;
  updating: Record<string, boolean>;
  fetchParams: TypedMap<{
    pageNum: number;
    limit: number;
    search: string;
  }>;
}>;

export const initialState = fromJS({
  loading: false,
  error: false,
  updating: {},
  fetchParams: {
    pageNum: 0,
    limit: 50,
    search: '',
  },
}) as OrganizersListPageState;

function organizersListPageReducer(
  state = initialState,
  action: AnyAction
): OrganizersListPageState {
  switch (action.type) {
    case INIT:
      return state.merge({ loading: true });

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case UPDATE:
      return state.setIn(['updating', action.userId], true);

    case UPDATE_SUCCESS:
      return state.setIn(['updating', action.userId], false);

    case UPDATE_FAILED:
      return state.setIn(['updating', action.userId], false);

    case SET_FETCH_PARAMS:
      return state.merge({
        loading: true,
        fetchParams: state.get('fetchParams').merge({ pageNum: 0, ...action.params }),
      });

    default:
      return state;
  }
}

export default organizersListPageReducer;
